import React from "react";
import PageHeader from "../../../components/ui/page header/PageHeader";
import NewsPageSection from "./components/newsSection/NewsPageSection";
import { useTranslation } from "react-i18next";

function NewsPage() {
  const { t } = useTranslation("news");
  return (
    <>
      <PageHeader
        topic={t("newsSection.topic")}
        topicSentence={t("newsSection.topicSentence")}
      />
      <NewsPageSection />
    </>
  );
}

export default NewsPage;
